<template>
    <USelectMenu
        v-model="accountNo"
        v-model:search-term="searchTerm"
        :items="incomeAccounts"
        size="sm"
        label-key="name"
        value-key="accountNo"
        :autofocus="autofocus"
        :default-open="defaultOpen"
        :ui="{ content: 'min-w-fit ' + theme}"
        placeholder="Konto"
        ignore-filter
    >
        <div v-if="accountNo" class="text-highlighted">{{ accountNo }}</div>
        <template #item="{item}">
            <div class="flex w-full gap-2">
                <div class="text-highlighted">
                    {{ item.accountNo }}
                </div>
                <div class="text-muted">
                    {{ item.name }}
                </div>
            </div>
        </template>
    </USelectMenu>
</template>

<script setup lang="ts">
import {computed, ref} from 'vue'
import {bookkeepingAccounts} from '@/bookkeeping-account/bookkeepingAccount.service'
import _ from 'lodash'

const searchTerm = ref('')

defineProps({
    theme: {type: String, default: ''},
    autofocus: {type: Boolean, default: false},
    defaultOpen: {type: Boolean, default: false}
})

const incomeAccounts = computed(() => {
    return _(bookkeepingAccounts.value)
        .filter(a => a.accountNo.startsWith('3'))
        .filter(a => {
            if (!searchTerm.value) return true
            const lowerSearch = searchTerm.value.toLowerCase()
            return a.accountNo.toLowerCase().includes(lowerSearch) ||
                a.name.toLowerCase().includes(lowerSearch)
        })
        .sortBy(a => Number(a.accountNo))
        .value()
})

const accountNo = defineModel<string | undefined>('accountNo')
</script>

<style scoped>

</style>